// extracted by mini-css-extract-plugin
export default {"item":"Cancel_item__vAA1l","item-wp":"Cancel_item-wp__WFbsT"};